import { useSubscription } from '@app/features/subscription/hooks/subscription';
import isTrialPlan from '@app/features/subscription/libs/isTrialPlan';
import useResponsiveValue from '@app/hooks/useResponsiveValue';
import { useHasPublicWorkspace } from '@app/hooks/workspace';

function useGNBGuideActive() {
  const hasPublicWorkspace = useHasPublicWorkspace();
  const { data: subscription, isSuccess: isSubscriptionFetchSuccess } = useSubscription();
  const isMobileWidth = useResponsiveValue([true, true, false]);
  return (
    isSubscriptionFetchSuccess &&
    (!subscription || isTrialPlan(subscription?.plan?.id)) &&
    !hasPublicWorkspace &&
    !isMobileWidth
  );
}

export default useGNBGuideActive;
